export enum ENavigationItemSegmentation {
  BY_CATEGORIES_AND_FAMILIES = '2',
  BY_PRODUCT_IDS = '3',
}
